/**
 * Default Queries Aggregator
 *
 * Combines all category-specific query files into a single DEFAULT_QUERIES export.
 * This maintains backward compatibility with existing code that imports DEFAULT_QUERIES.
 *
 * Query categories are organized in separate locations:
 * - securityAdvisories.ts: 7 CVE queries
 * - adAttackPaths/: 45 Active Directory queries (organized by subcategory)
 * - cloudAttackPaths.ts: 1 cloud infrastructure query
 * - commonQueries.ts: 3 common queries
 *
 * To add a new AD query: Navigate to adAttackPaths/ directory and edit the appropriate category file.
 * To add other queries: Edit the appropriate category file in this directory.
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { AD_ATTACK_PATH_QUERIES } from './adAttackPaths';
import { CLOUD_ATTACK_PATH_QUERIES } from './cloudAttackPaths';
import { COMMON_QUERIES } from './commonQueries';
import { CONCERNING_EXPOSURE_QUERIES } from './concerningExposureQueries';
import { SECURITY_ADVISORY_QUERIES } from './securityAdvisories';

/**
 * Complete array of all default queries.
 * Maintains backward compatibility - consumers import this single array.
 */
export const DEFAULT_QUERIES: SavedQuery[] = [
  ...COMMON_QUERIES,
  ...CONCERNING_EXPOSURE_QUERIES,
  ...AD_ATTACK_PATH_QUERIES,
  ...CLOUD_ATTACK_PATH_QUERIES,
  ...SECURITY_ADVISORY_QUERIES,
];
